/**
 * FlyMeta 应用配置中心
 *
 * 环境标识通过 REACT_APP_SLOT_ID 注入:
 *   - 未设置 / "dev"  → [DEV] 开发主实例 (绿色 favicon)
 *   - "1" / "2" / "3" → [S1] [S2] [S3] Slot 实例 (橙/紫/青 favicon)
 *   - 生产环境无此变量, NODE_ENV=production → 无前缀 (蓝色 favicon)
 */

// 环境判断
export const IS_DEV = process.env.NODE_ENV === "development" || process.env.REACT_APP_ENV === "development";

// Slot 标识: "dev" | "1" | "2" | "3" | null(生产)
const SLOT_ID = process.env.REACT_APP_SLOT_ID || null;

/**
 * 根据环境生成 favicon
 */
const getEnvBranding = () => {
    if (!IS_DEV) {
        // 生产环境使用默认蓝色 favicon
        return { favicon: "/favicon.svg" };
    }

    if (SLOT_ID && SLOT_ID !== "dev") {
        // Slot 实例
        return {
            favicon: `/favicon-slot${SLOT_ID}.svg`,
        };
    }

    // 开发主实例
    return { favicon: "/favicon-dev.svg" };
};

const ENV_BRANDING = getEnvBranding();
export const APP_SYSTEM_NAME = "货机资产运营平台";

// 应用信息
export const APP_INFO = {
    NAME: APP_SYSTEM_NAME,
    FULL_NAME: APP_SYSTEM_NAME,
    VERSION: "1.0.0",
    DESCRIPTION: "航空货运管理系统",
    FAVICON: ENV_BRANDING.favicon,
    SLOT_ID: SLOT_ID,
    IS_SLOT: IS_DEV && SLOT_ID && SLOT_ID !== "dev",
};
